module.exports = __webpack_public_path__ + "img/⾼效的机器学习模型推理能⼒.99775c68.png";